import { fabric } from "fabric";
import customControls from "./customControlsHelper";
import { ModuleInfoImage } from "../../Types";

export default {
  handleTextLogo_ImageChange,
};

/**
 * @method handleTextLogo_ImageChange
 * @param moduleInfo {ModuleInfo} Full order information
 * @param canvas {fabricCanvasInstance} Fabric instance that is to be edited
 * @returns void
 * @description Method used to handle changes for logo image.
 * If the image does not exist it creates it first, otherwise it will replace it.
 */
export function handleTextLogo_ImageChange(
  images: ModuleInfoImage[],
  canvas: fabric.Canvas
): void {
  let allObj = canvas.getObjects();
  allObj.forEach((element: fabric.Object) => {
    // @ts-ignore
    if (element.type === "image" || element.customType === "image") {
      canvas.remove(element);
    }
  });

  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();
  fabric.Image.fromURL(images[0].renderUrl, (img) => {
    // if the image's being uploaded sizes are greater that canvas size than scale it down
    if (img.width > canvasWidth) {
      img.scaleToWidth(canvasWidth / 2);
    }
    if (img.height > canvasHeight) {
      img.scaleToHeight(canvasHeight / 2);
    }
    img.set({
      // @ts-ignore
      id: `image-0`,
      originX: "center",
      originY: "center",
      left: canvasWidth / 2,
      top: canvasHeight / 2,
      lockScalingFlip: true,
      lockUniScaling: true,
    });
    // @ts-ignore
    img.customiseCornerIcons(customControls());
    canvas.add(img);
  });
}
